import { Box, Button, Typography } from "@mui/material";
import { createEffect } from "effector";
import api from "../../Auth/api";
import { updateModal } from "../ErrorModal";

export default function FileUpload({ files, onUpload, onDelete }) {

    const uploadFile = createEffect(async ({ formData }) => {
        api.post(`multimedia/upload`, formData)
            .then(
                (res) => onUpload(res?.data.data),
                error => updateModal(error.response.data.errors)
            )
    })

    const handleFiles = (event) => {
        [...event.target.files].forEach(file => {
            const formData = new FormData()
            formData.append('file', file)
            uploadFile({ formData })
        })
    }

    return (
        <Box display="flex" flexDirection="column" gap={3}>
            {files.length
                ? <Box>
                    {files.map((file) => (
                        <Box
                            className={`file-box`}
                            key={file.id}
                            id={file.id}
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            gap={2}
                        >
                            <Typography align="center">{file.name}</Typography>
                            <Button color="error" onClick={() => onDelete(file.id)}>Удалить</Button>
                        </Box>
                    ))}
                </Box>
                : <></>}
            <Button variant="contained" component="label" disableElevation>
                Загрузить файл
                <input hidden accept="file/*" type="file" onChange={handleFiles} />
            </Button>
        </Box>
    );
}